import VendorList from './VendorList'

export default VendorList

